<script>
  import clsx from "clsx";
  import { Router, Route } from "yrv/build/dist";
  import { onMount } from "svelte";
  import { operationStore, query } from "@urql/svelte";
  import { ClickStoryApi } from "../Api/clickstory";
  import { clickStoryData, clickStoryUrlData, adData, nanoID } from "../Api/store";
  import ClickStory from "./ClickStory.svelte";
  import Advertisement from "../Component/Advertisement.svelte";

  export let itemId;
  export let baseUrl;
  export let sticky;

  const urlPathId = "newsbild";

  const clickStory = operationStore(ClickStoryApi, {
    clickStoryId: parseInt(itemId),
  });

  query(clickStory);

  clickStory.subscribe((storeObj) => {
    if (storeObj.data) {
      clickStoryData.set(storeObj.data.clickStory);
    }
  });

  onMount(() => {
    if (baseUrl.match(/newsbild\/\d+/)) {
      baseUrl = baseUrl.replace(/(.*)\/newsbild\/\d+/, "$1");
    }

    clickStoryUrlData.set(baseUrl);
  });
</script>

{#if $clickStoryData}
  <h2 class="sr-only" id={`headline-${$nanoID}`}>Klickstrecke</h2>
  <div class={clsx("relative", sticky && "z-0")}>
    <Advertisement />
    <div class={$adData.show ? "pointer-events-none blur" : null}>
      <Router>
        <Route exact path={baseUrl} component={ClickStory} {urlPathId} />
        <Route exact path={`${baseUrl}/${urlPathId}/:itemId`} {urlPathId} component={ClickStory} />
      </Router>
    </div>
  </div>
{:else}
  <p class="text-center">Klickstrecke wird geladen...</p>
{/if}
